export class CreateApplicationValuerPvConstants {
    static MUNICIPAL_VALUER_FORM_CONTROL_NAME = "municipalValuerRecipient";
    static ASSISTANT_VALUER_FORM_CONTROL_NAME = "assistantValuerRecipient";
    static DATA_COLLECTOR_FORM_CONTROL_NAME = "dataCollectorRecipient";
    static DATA_COLLECTORS_LABEL = "Data collectors";
    static MUNICIPAL_LABEL = "Municipal valuer";
    static ASSISTANT_VALUER_LABEL = "Assistant valuer";
    static ASSISTANT_VALUERS_LABEL = "Assistant valuers";
}
